module.exports = __webpack_public_path__ + "static/media/k4.82b3a3e1.jpg";